export function setPresets() {
  ymaps.option.presetStorage.add('fixmobile#withLogo', {
    iconLayout: 'default#image',
    iconImageHref: '/images/map/pin-small.svg',
    iconImageSize: [32, 52],
    iconImageOffset: [-16, -52]
  });

  ymaps.option.presetStorage.add('fixmobile#ozon', {
    iconLayout: 'default#image',
    iconImageHref: '/images/map/pin-ozon-small.svg',
    iconImageSize: [32, 52],
    iconImageOffset: [-16, -52]
  });

  ymaps.option.presetStorage.add('fixmobile#ozon-active', {
    iconLayout: 'default#image',
    iconImageHref: '/images/map/pin-ozon-small-active.svg',
    iconImageSize: [32, 52],
    iconImageOffset: [-16, -52]
  });

  ymaps.option.presetStorage.add('fixmobile#postamat', {
    iconLayout: 'default#image',
    iconImageHref: '/images/map/pin-postamat-small.svg',
    iconImageSize: [32, 52],
    iconImageOffset: [-16, -52]
  });

  ymaps.option.presetStorage.add('fixmobile#postamat-active', {
    iconLayout: 'default#image',
    iconImageHref: '/images/map/pin-postamat-small-active.svg',
    iconImageSize: [32, 52],
    iconImageOffset: [-16, -52]
  });

  ymaps.option.presetStorage.add('fixmobile#cdek', {
    iconLayout: 'default#image',
    iconImageHref: '/images/map/pin-cdek-small.svg',
    iconImageSize: [32, 52],
    iconImageOffset: [-16, -52]
  });

  ymaps.option.presetStorage.add('fixmobile#cdek-active', {
    iconLayout: 'default#image',
    iconImageHref: '/images/map/pin-cdek-small-active.svg',
    iconImageSize: [32, 52],
    iconImageOffset: [-16, -52]
  });
}

export function installPresets(e) {
  // object – объект, который был добавлен в коллекцию.
  const object = e.get('child');

  switch (object.options.preset) {
    case 'fixmobile#ozon':
      this.objects.setObjectOptions(object.id, {
        preset: 'fixmobile#ozon'
      });
      break;
    case 'fixmobile#ozon-active':
      this.objects.setObjectOptions(object.id, {
        preset: 'fixmobile#ozon-active'
      });
      break;
    case 'fixmobile#postamat':
      this.objects.setObjectOptions(object.id, {
        preset: 'fixmobile#postamat'
      });
      break;
    case 'fixmobile#postamat-active':
      this.objects.setObjectOptions(object.id, {
        preset: 'fixmobile#postamat-active'
      });
      break;
    case 'fixmobile#cdek':
      this.objects.setObjectOptions(object.id, {
        preset: 'fixmobile#cdek'
      });
      break;
    case 'fixmobile#cdek-active':
      this.objects.setObjectOptions(object.id, {
        preset: 'fixmobile#cdek-active'
      });
      break;
    default:
      this.objects.setObjectOptions(object.id, {
        preset: 'fixmobile#withLogo'
      });
      break;
  }
}
